import { Flame, Prohibit } from "@phosphor-icons/react";
import { Reveal, ChapterTag } from "./primitives";

const BuybackBurn = () => (
  <section className="relative py-24 lg:py-32 border-t border-line" data-testid="buyback-burn-section">
    <div className="section-shell grid gap-12 lg:grid-cols-2 lg:gap-20 items-start">
      <div>
        <Reveal>
          <ChapterTag index={9} label="Buyback & Burn" />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display font-bold tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl" data-testid="buyback-headline">
            <span className="text-gold">Selective Deflation.</span>
            <br />
            <span className="text-mist">No Transaction Tax.</span>
          </h2>
        </Reveal>
      </div>
      <div className="space-y-5">
        <Reveal delay={0.15}>
          <div className="card-surface rounded-xl p-8 flex gap-5">
            <Flame size={28} className="text-gold shrink-0 mt-1" aria-hidden="true" />
            <p className="text-sm sm:text-base text-slate leading-relaxed" data-testid="buyback-explanation">
              Jovino Coin is not inherently deflationary through transaction taxes. The ecosystem may periodically use
              revenue generated from ecosystem services to purchase JCV on the open market. Purchased tokens may then be
              transferred to an irrecoverable burn address, permanently reducing circulating supply.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.25}>
          <div className="card-surface rounded-xl p-8 flex gap-5">
            <Prohibit size={28} className="text-teal shrink-0 mt-1" aria-hidden="true" />
            <p className="text-sm sm:text-base text-slate leading-relaxed" data-testid="buyback-note">
              Buyback frequency and size are <span className="text-mist">not guaranteed</span>. They are subject to
              transparent policies and, over time, community approval through governance.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default BuybackBurn;
